export default __webpack_public_path__ + "static/media/error-icon.de45bb4c.svg";